import React, { useMemo, useCallback, useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ViewModelServiceContext, withViewModelService, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLCareAntiSteeringWarningService } from 'gw-capability-fnol';
import { ClaimService } from 'gw-capability-claim';
import { useAuthentication } from '@xengage/gw-digital-auth-react';

import metadata from './MLClaimDetailsSelfServe.metadata.json5';
import messages from './MLClaimDetailsSelfServe.messages';
import styles from './MLClaimDetailsSelfServe.module.scss'

function MLClaimDetailsSelfServe(props) {
    const {
        policyBaseState,
        insuredVehicleIncident,
        claimNumber,
        claimLossCause,
        mainContact,
        isServiceRequestMade,
        isVehicleRepairable,
        isSelfServiceAvailable,
        history
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const ModalService = MLModalService();

    const stateTypekeys = useMemo(() => {
        viewModelService.productMetadata.get('cc').types.getTypelist('State');
    }, [viewModelService.productMetadata]);

    const getPolicyStateTypeKeyCode = useCallback(() => {
        return stateTypekeys && stateTypekeys.codes.find((state) => state.name === policyBaseState).code;
    }, [policyBaseState, stateTypekeys]);

    const antiSteeringWarning = useMemo(() => {
        if(policyBaseState && stateTypekeys){
            const careAntiSteeringWarnings = MLCareAntiSteeringWarningService.getDisclaimer(getPolicyStateTypeKeyCode());
            return careAntiSteeringWarnings.content[0].text;
        }
    }, [policyBaseState, stateTypekeys, getPolicyStateTypeKeyCode]);

    const shouldShowEFTOption = () => {
        return claimLossCause !== 'towing_ml';
    }

    const onEFTEnrollmentClick = useCallback(() => {
        const eftPromise = ClaimService.getEFTEnrollmentUrl(claimNumber, authHeader);
        eftPromise.then((url) => {
            window.open(url, '_blank');

        }).catch((e) => {
            console.error(e);
        });
    }, [authHeader, claimNumber]);

    const onFindCareShopsClick = useCallback(() => {
        const defaultSearchCriteriaRequest = ClaimService.getDefaultSearchCriteria(claimNumber, authHeader);
        ModalService.showProgressDialog(messages.loading, defaultSearchCriteriaRequest);
        defaultSearchCriteriaRequest.then((defaultSearchCriteria) => {
            if (defaultSearchCriteria) {
                history.push('/care-shops', {claimNumber: claimNumber, searchCriteria: defaultSearchCriteria, insuredVehicleIncident: insuredVehicleIncident, isServiceRequestMade: isServiceRequestMade});
            }
        });
    }, [ModalService, authHeader, claimNumber, history, insuredVehicleIncident, isServiceRequestMade]);

    const onEmaiOrSMSlLinkClick = useCallback((emailOrSMS, contactInfo) => {
        const cccServiceRequest = ClaimService.cccServiceRequestForEmailorSMS(claimNumber, emailOrSMS, contactInfo, authHeader);
        ModalService.showProgressDialog(messages.RequestingService, cccServiceRequest);
        cccServiceRequest.then((cccService) => {
            if (cccService && cccService === 'SUCCESS') {
                ModalService.showInfo(messages.ServiceRequest, messages.ServiceRequestCreated);
                history.push('/details', {claimNumber: claimNumber});
            } else {
                ModalService.showErrorModal(messages.ErrorRequestingService);
            }
        }).catch(()=> {
            ModalService.showErrorModal(messages.UnableToBookAppointment);
        });
    }, [ModalService, authHeader, claimNumber, history]);

    const onEmailLinkClick = useCallback(() => {
        onEmaiOrSMSlLinkClick('EMAIL', _.get(mainContact, 'emailAddress1'));
    }, [mainContact, onEmaiOrSMSlLinkClick])

    const onTextLinkClick = useCallback(() => {
        onEmaiOrSMSlLinkClick('SMS', _.get(mainContact, 'cellNumber'));
    }, [mainContact, onEmaiOrSMSlLinkClick])
    
    const writeValue = (value, path) => {
        if(path==="cellNumber"){
            value = value.replace(/[^\d]/g, '')
        }
        _.set(mainContact, path, value);
        refreshData();
    };

    const overrides = {
        EFTEnrollmentContent: {
            visible: shouldShowEFTOption()
        },
        selfServiceAvailable: {
            visible: !!isSelfServiceAvailable
        },
        vehicleRepairable: {
            visible: !!isVehicleRepairable
        },
        antiSteeringWarning: {
            content: antiSteeringWarning
        },
        emailMeTheLink: {
            value: _.get(mainContact, 'emailAddress1'),
            onValueChange: (value) => writeValue(value, 'emailAddress1')
        },
        emailMeTheLinkButton: {
            disabled: !!isServiceRequestMade
        },
        cellPhoneNumber: {
            value: _.get(mainContact, 'cellNumber'),
            onValueChange: (value) => writeValue(value, 'cellNumber')
        },
        textMeTheLinkButton: {
            disabled: !!isServiceRequestMade
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
            onEFTEnrollmentClick,
            onFindCareShopsClick,
            onEmailLinkClick,
            onTextLinkClick
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}

export default withRouter(withViewModelService(MLClaimDetailsSelfServe));